import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Receipt, FolderOpen, Upload, PieChart, TrendingUp, Settings as SettingsIcon, LogOut, Home, ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';

const Layout = ({ children, user, onLogout }) => {
  const location = useLocation();
  const isAdmin = user?.email === 'admin@mybudgettracker.com.au';

  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
    { name: 'Transactions', href: '/transactions', icon: Receipt },
    { name: 'Categories', href: '/categories', icon: FolderOpen },
    { name: 'Budget', href: '/budget', icon: PieChart },
    { name: 'Insights', href: '/insights', icon: TrendingUp },
    { name: 'Import', href: '/import', icon: Upload },
    { name: 'Settings', href: '/settings', icon: SettingsIcon },
  ];

  // Add Admin link only for admin user
  if (isAdmin) {
    navigation.push({ name: 'Admin', href: '/admin', icon: ShieldCheck, isAdmin: true });
  }

  return (
    <div className="flex h-screen bg-background" data-testid="app-layout">
      <aside className="w-64 border-r border-border bg-card flex flex-col">
        <div className="p-4 border-b border-border">
          <button
            onClick={onLogout}
            className="text-left group w-full"
            title="Go to Home Page"
            data-testid="home-logo-button"
          >
            <img 
              src="/logo-banner.png" 
              alt="My Budget Tracker" 
              className="w-full h-auto rounded-sm"
            />
          </button>
          <p className="text-xs font-mono text-muted-foreground mt-2 uppercase tracking-wider">
            {user?.name || 'User'}
          </p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                data-testid={`nav-${item.name.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-sm text-sm font-body font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : item.isAdmin 
                      ? 'text-amber-600 hover:bg-amber-50 hover:text-amber-700 border border-amber-200'
                      : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                }`}
              >
                <Icon className="h-5 w-5" />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-border">
          <Button
            variant="ghost"
            className="w-full justify-start gap-3"
            onClick={onLogout}
            data-testid="logout-button"
          >
            <LogOut className="h-5 w-5" />
            Logout
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
